<template>
    <el-dialog :visible.sync="show" width="600px" append-to-body :before-close="closeDialog">
        <div class="form-box">
            <div style="width: 300px; margin: 0 auto; margin-bottom: 20px">
                <div class="text-box">
                    <span>类型 </span>
                    <el-select v-model="submit_data.income_type" placeholder="请选择类型" style="width: 200px; margin-left: 10px">
                        <el-option label="司机服务费" value="1"> </el-option>
                        <el-option label="活动金" value="0"> </el-option>
                    </el-select>
                </div>
                <div class="text-box">
                    <span>金额 </span>
                    <el-input v-model="amount" placeholder="余额" style="width: 200px; margin-left: 10px"> </el-input>
                </div>
                <!-- <div class="text-box">
                    <span>渠道 </span>
                    <el-select v-model="submit_data.trade_type" placeholder="请选择类型" style="width: 200px; margin-left: 10px">
                        <el-option label="微信小程序" value="T_MINIAPP"> </el-option>
                        <el-option label="支付宝小程序" value="A_JSAPI"> </el-option>
                    </el-select>
                </div> -->
            </div>

            <div style="display: flex; justify-content: center;align-items:center">
                <el-radio-group v-model="radio" @change="radioChange">
                    <el-radio label="1" border>对公账户充值</el-radio>
                    <el-radio label="T_MINIAPP" border>微信充值</el-radio>
                    <el-radio label="A_JSAPI" border>支付宝充值</el-radio>
                </el-radio-group>
                <el-tooltip
                    style="margin-left:10px"
                    class="item"
                    effect="dark"
                    content="扫码支付每笔收取千分之六手续费，公户支付每笔收取14元手续费"
                    placement="right"
                >
                    <i class="el-icon-question"></i>
                </el-tooltip>
            </div>
            <div style="display: flex; align-items: center; flex-direction: column; margin-top: 20px">
                <el-button type="primary" @click="submitBtn" v-if="radio == '1'">支付</el-button>
                <el-button v-else type="primary" @click="handlePayWxQRcode">获取充值二维码</el-button>
            </div>

            <div style="display: flex; align-items: center; flex-direction: column; margin-top: 20px" v-if="wxpayUrl">
                <h1 style="font-size: 30px; color: #05c0ab">
                    {{ submit_data.trade_type == '' ? '' : submit_data.trade_type == 'T_MINIAPP' ? '微信' : '支付宝' }}扫一扫支付
                </h1>
                <el-image :src="wxpayUrl" v-loading="loading">
                    <div slot="error">加载中<span class="dot">...</span></div>
                </el-image>
                <div>注：若二维码过期失效，请重新填写要充值的金额获取二维码！</div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
var _this;
let myTimer;
import axios from 'axios'; // AJAX封装类
import { config } from '@/utils/config'; //配置

export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newDate, oldData) {
            _this.show = true;
            if (myTimer) {
                clearTimeout(myTimer);
            }
        }
    },
    data() {
        return {
            radio: '1',
            amount: '',
            loading: false,
            show: false,
            wxpayUrl: '',

            // 表单数据
            submit_data: {
                amount: '',
                income_type: '',
                trade_type: ''
            },
            submit_rules: {
                amount: {
                    placeholder: '余额',
                    rules: {
                        required: true,
                        message: '余额需要大于0的数字',
                        regulation: 'number',
                        rulesData: 0
                    }
                },
                income_type: {
                    placeholder: '类型',
                    rules: {
                        required: true,
                        message: '类型为必填项',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },

    methods: {
        // 充值支付 对公账户
        submitBtn() {
            // 点击支付按钮
            _this.submit_data.amount = Number(_this.amount).toFixed(2); // 输入1提交数据的时候变成1.00

            _this
                .$post('/huifu/income', _this.submit_data, _this.submit_rules)
                .then((res) => {
                    console.log(res.data.form_url, 'res.data');

                    // console.log(res.data.form_url,_blank,'res.data.form_url,_blank');// 打印的时候多了一个_blank 是undefined编译错误，代码没往下执行
                    // window.location.href = res.data.form_url;
                    window.open(res.data.form_url, '_blank');
                })
                .catch((err) => {});
        },
        radioChange(val) {
            if (myTimer) {
                clearTimeout(myTimer);
            }
            if (val == '1') {
                // 如果从微信支付或者支付宝支付切换过来，那两个有轮询，需要先取消轮询定时器
            }
            _this.wxpayUrl = ''; // 如果从微信支付切换到支付宝支付需要清空二维码，重新获取充值二维码
            _this.submit_data.trade_type = val;
        },

        //获取充值二维码
        handlePayWxQRcode() {
            // 点击微信支付或者支付宝支付
            _this.submit_data.trade_type = _this.radio;
            _this.submit_data.amount = Number(_this.amount).toFixed(2); // 输入1提交数据的时候变成1.00

            console.log(_this.submit_data.trade_type, '_this.submit_data.trade_type');
            _this.$post('/huifu/incomePerson', this.submit_data, _this.submit_rules).then((res) => {
                _this.wxpayUrl = res.data.qr_img;
                this.loading = false;

                _this.payStatus(res.data.req_seq_id);
            });
        },

        payStatus(val) {
            clearTimeout(myTimer);
            console.log(111);
            // p 处理中    s 成功     F 失败

            _this.$post('/huifu/payStatus', { req_seq_id: val }).then((res) => {
                let status = res.data.status;

                if (status == 'P') {
                    myTimer = setTimeout(() => {
                        _this.payStatus(val);
                    }, 3000);
                } else if (status == 'S') {
                    setTimeout(() => {
                        clearTimeout(myTimer);
                        _this.$emit('onSubmit');

                        _this.closeDialog();
                    }, 2000);
                } else if (status == 'F') {
                    myTimer = setTimeout(() => {
                        _this.payStatus(val);
                    }, 3000);
                }
            });
        },
        // 轮询,定时器查询支付状态，如果状态不是完成，每3秒查询一下状态，如果状态为完成，则关闭充值二维码页面
        // payStatus(val) {
        //     clearTimeout(myTimer);
        //     axios.defaults.baseURL = config.axios_normalURL;

        //     _this.$post('/wechat/payStatus', { trade_no: val }).then((res) => {
        //         axios.defaults.baseURL = config.axios_baseURL; //请求base url

        //         if (res.data.status != '1') {
        //             myTimer = setTimeout(() => {
        //                 _this.payStatus(val);
        //             }, 3000);
        //         } else {
        //             _this.$emit('onSubmit');

        //             _this.closeDialog();
        //         }
        //     });
        //     axios.defaults.baseURL = config.axios_baseURL; //请求base url
        // },

        // 关闭方法
        closeDialog() {
            _this.radio = '1';
            if (myTimer) {
                clearTimeout(myTimer);
            }

            _this.show = false;

            _this.loading = false;

            _this.wxpayUrl = '';

            for (const key in _this.submit_data) {
                _this.submit_data[key] = '';
            }
        }
    }
};
</script>
<style scoped>
.recharge-btn {
    display: flex;
}
.form-box {
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
}
.recharge-span {
    font-size: 18px;
    margin: 10px 0;
}
</style>
<style>
.recharge-btn .el-button--info {
    border: 1px solid #05c0ab;
    background-color: #fff;
    color: #05c0ab;
}
.form-box .el-image__inner {
    width: 220px;
}
.text-box {
    margin-top: 10px;
}
</style>
